import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cache: {},   // { filterKey: { pageNumber: [activities] } }
  total: {},   // { filterKey: totalCount }
};

const coachActivitiesSlice = createSlice({
  name: "coachActivities",
  initialState,
  reducers: {
    resetCoachActivities(state) {
      state.cache = {};
      state.total = {};
    },

    storeCoachActivitiesPage(state, action) {
      const { key, page, items, total } = action.payload;

      if (!state.cache[key]) {
        state.cache[key] = {};
      }

      state.cache[key][page] = items;
      state.total[key] = total;
    },
  },
});

export const {
  resetCoachActivities,
  storeCoachActivitiesPage,
} = coachActivitiesSlice.actions;

export default coachActivitiesSlice.reducer;
